import { render, staticRenderFns } from "./ReloadProducts.vue?vue&type=template&id=58b5abe0&scoped=true&"
import script from "./ReloadProducts.vue?vue&type=script&lang=js&"
export * from "./ReloadProducts.vue?vue&type=script&lang=js&"
import style0 from "./ReloadProducts.vue?vue&type=style&index=0&id=58b5abe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b5abe0",
  null
  
)

export default component.exports